import { formatFallbackInterval } from '../../../shared/utils/formatFallbackInterval.ts';
import { Protocol } from '../../types/sharedTypeImpl.ts';
import { Change } from './change.ts';
import { getFieldChange, getSimpleChange } from './getChange.ts';


export function getMeasurementPlanChanges(protocolNew: Protocol, protocolOld: Protocol): Change[] {
    const changes: (Change | null)[] = [];

    const oldMeasurementPlan = protocolOld.measurementPlan;
    const newMeasurementPlan = protocolNew.measurementPlan;
    if (!oldMeasurementPlan && newMeasurementPlan) {
        changes.push({
            path: ['Measurement plan'],
            changeDescription: 'Added',
            changeType: 'add',
        });
    } else if (oldMeasurementPlan && newMeasurementPlan) {
        const oldFallbackInterval = formatFallbackInterval(oldMeasurementPlan.fallbackIntervalMs);
        const newFallbackInterval = formatFallbackInterval(newMeasurementPlan.fallbackIntervalMs);
        changes.push(getSimpleChange(newFallbackInterval, oldFallbackInterval, ['Fallback interval']));

        changes.push(getFieldChange(newMeasurementPlan, oldMeasurementPlan, 'variantSequence', ['Variant sequence']));

        for (const newVariant of newMeasurementPlan.variants) {
            const oldVariant = oldMeasurementPlan.variants.find((variant) => variant.name === newVariant.name)!;
            for (const newPosition of protocolNew.positions) {
                const id = newPosition.id;
                const newCount = newVariant.positions[id] || null;//convert 0 to null, to show value as being added/removed
                const oldCount = oldVariant.positions[id] || null;
                const positionNumber = '#' + newPosition.positionNumber;
                const path = [newVariant.name, positionNumber];
                const change = getSimpleChange(newCount, oldCount, path);
                changes.push(change);
            }
        }
    }
    return changes.filter((change) => change !== null) as Change[];
}
